import React, {useState, useEffect} from 'react'
import { motion } from 'framer-motion'
import { urlFor, client } from '../../client'
import { AppWrap, MotionWrap } from '../../wrapper'

import './About.scss'

// const abouts = [
//   { title: 'Web Development', description: 'I am a good web development', imgUrl: images.about01 },
//   { title: 'Web Design', description: 'I am a good web designer', imgUrl: images.about02 },
//   { title: 'Web Animations', description: 'I am a good web animations', imgUrl: images.about03 },
//   { title: 'UI/UX', description: 'I am a good UI/UX designer', imgUrl: images.about04 }
// ]

const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]';
    
    client.fetch(query).then((data) => setAbouts(data))

  }, [])
  

  return (
    <>
      <div className="about section">
        <span className='subtitle'>Services</span>
        <h1 className='title'>
          What I Offer
        </h1>
      </div>

      <div className="app__profiles">
        {abouts.map((about, index) => {
          return (
            <motion.div
              whileInView={{ opacity: 1 }}
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: 'tween' }}
              className="app__profile-item"
              key={about.title + index}
            >
              <img src={urlFor(about.imgUrl)} alt={about.title} />
              <h2 className="bold-text" style={{ marginTop: 20 }}>
                {about.title}
              </h2>
              <p className="p-text" style={{ marginTop: 10 }}>
                {about.description}
              </p>
            </motion.div>
          )
        })}
      </div>
    </>
  )
}

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg'
)